import { formatPhoneDisplay } from "../../utils/formatPhone";
import "./FooterPhoneLink.css";

function FooterPhoneLink({ phone, className = "" }) {
  if (!phone) return null;

  return (
    <a href={`tel:${phone}`} className={`caf-phone-ltr ${className}`.trim()} dir="ltr">
      {formatPhoneDisplay(phone)}
    </a>
  );
}

export default FooterPhoneLink;
